import * as Yup from 'yup'

export const pagarNotaSchema = Yup.object().shape({
  pdf: Yup.mixed()
    .required('O comprovante é obrigatório')
    .test('fileType', 'O arquivo deve ser um PDF', (value: File) => {
      return value && value.type === 'application/pdf'
    }),
})
